module.exports = __webpack_public_path__ + "static/media/accMselected.74302561.svg";